// extracted by mini-css-extract-plugin
module.exports = {"section":"A_section__DTS4y","scrollUp":"A_scrollUp__w3mAM"};